/**
 * СВЕТЯЩИЕСЯ НИТИ на поле: пути влияния гильдий и храмов, связи ферм, путь
 * снабжения от фермы к отряду и его оборванная часть. В одной гамме с анимациями
 * улучшения отряда и передачи размера: темная подложка держит линию на светлых
 * подложках поля, поверх нее ореол и яркая сердцевина, по нити бегут огоньки.
 *
 * Рисует scenes/GlowingThreads, текстуры считает код
 * (utils/effects/glowThreadTextures). Размеры — доли размера ячейки.
 */

export const GLOW_THREAD_TEXTURE_KEYS = {
  // Полоса с плотной серединой и мягким краем (белая, красится tint)
  CORE: 'glow_thread_core',
  // Полоса, мягко гаснущая от середины к краям: ореол и темная подложка
  HALO: 'glow_thread_halo',
  // Точка на конце нити и на фермах
  NODE: 'glow_thread_node',
  // Стрелка на точке транзита снабжения: смотрит вправо, поворачивается по маршруту
  ARROW: 'glow_thread_arrow',
  // Черта на точке, где снабжение не проходит дальше
  STRIKE: 'glow_thread_strike',
};

// Что лежит на точке обрыва пути снабжения: черный колос, перечеркнутый красной чертой. Текстура
// колоса белая, цвет дает тон; загружается вместе с полем (GameScene). Ось колоса на картинке идет
// снизу слева вверх направо, черта — поперек нее, и концами упирается в темный ободок точки, не заходя на него
export const SUPPLY_BLOCKED_NODE_OVERLAYS = [
  {textureKey: 'supply_white', tint: 0x000000, sizeFactor: 1.5},
  {textureKey: GLOW_THREAD_TEXTURE_KEYS.STRIKE, tint: 0xd3201c, sizeFactor: 1.84, rotation: Math.PI / 4},
];

export const GLOW_THREAD_PALETTES = {
  // Гильдии: золото
  GUILD: {core: 0xffd93d, halo: 0xffa200, mote: 0xfff6c9, shadowAlpha: 0.7, haloAlpha: 1},
  // Храмы: серебро с белой сердцевиной
  TEMPLE: {core: 0xffffff, halo: 0x9db8ea, mote: 0xffffff, shadowAlpha: 0.8, haloAlpha: 1},
  // Снабжение: теплый свет цвета снабжения (SUPPLY_COLOR), светлее и ярче его
  SUPPLY: {core: 0xfff0d2, halo: 0xf07f35, mote: 0xfffaf0, shadowAlpha: 0.7, haloAlpha: 1},
  // Оборванный путь: нить погасла, в темноте едва тлеют угольки
  BROKEN: {core: 0x1d1917, halo: 0x5a1408, mote: 0xff6a2b, shadowAlpha: 0.5, haloAlpha: 0.8, moteSizeFactor: 0.34},
};

export const GLOW_THREAD = {
  coreWidthFactor: 0.28,
  haloWidthFactor: 1.05,
  shadowWidthFactor: 0.5,
  // Огоньки: один на столько ячеек пути, бегут с такой скоростью (ячеек в секунду)
  moteSpacingFactor: 1.5,
  minMotes: 2,
  moteSpeedFactor: 2.6,
  moteSizeFactor: 0.62,
  // Огонек на переднем крае нити, пока она тянется
  headSizeFactor: 1.15,
  // Нить тянется от начала к концу: столько на ячейку пути, в этих пределах
  revealMsPerHexSize: 110,
  minRevealMs: 320,
  maxRevealMs: 1100,
  // Точка на конце нити: она раздувается, когда нить дотянулась
  node: {
    radiusFactor: 0.34,
    smallRadiusFactor: 0.14,
    haloFactor: 3.2,
    haloAlpha: 0.75,
    popMs: 240,
    pulseMs: 1100,
    pulseScale: 0.1,
    // Стрелка транзита: темная на светлой точке, почти во всю ее ширину
    arrowTint: 0x6b3410,
    arrowSizeFactor: 1.5,
  },
};
